import { Box, BoxProps } from '@hover/blueprint';
import { forwardRef } from '@hover/blueprint/chakra';
import React from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';

export type BoxLinkProps = BoxProps & RouterLinkProps;

// TODO: compose `Link` component to inherit
// tracking + query parameter functionality
const SystemRouterLink = forwardRef<
  BoxLinkProps & { navigate: () => void },
  'a'
>(({ children, navigate, href, ...props }, ref) => {
  const onLinkClick: BoxProps['onClick'] = event => {
    event.preventDefault();
    props.onClick?.(event);
    navigate();
  };

  return (
    <Box
      {...props}
      as="a"
      href={href}
      onClick={onLinkClick}
      ref={ref}
      rel="noopener noreferrer"
      textDecoration="none"
    >
      {children}
    </Box>
  );
});

const BoxLink = (props: BoxLinkProps) => (
  <RouterLink component={SystemRouterLink} {...props} />
);

export { BoxLink };
